import { Frame, FrameHeader, FramePanel } from "@volca/ui/components/ui/frame";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

/** Representative title widths so skeleton rows don't all look identical. */
const SKELETON_TITLE_WIDTHS = ["w-64", "w-52", "w-56", "w-48"];

export const InvoiceGroupCardSkeleton = ({ rows = 3 }: { rows?: number }) => (
  <Frame stacked dense className="w-full">
    <FrameHeader>
      <Stack
        direction="column"
        justify="between"
        align="stretch"
        gap={2}
        className="w-full sm:flex-row sm:items-center sm:gap-4"
      >
        <Stack align="start" gap={0} className="min-w-0 sm:flex-1">
          <Stack direction="row" gap={2} align="center">
            <Skeleton className="h-5 w-36" />
            <Skeleton className="h-5 w-20 rounded-full" />
          </Stack>
          <Stack direction="row" gap={4} align="center" className="mt-1.5">
            <Skeleton className="h-3.5 w-40 sm:w-64" />
            <span className="h-5 w-px bg-line" aria-hidden />
            <Skeleton className="h-3.5 w-16" />
          </Stack>
        </Stack>
        <Stack
          direction="row"
          gap={2}
          align="center"
          justify="start"
          className="flex-none sm:justify-end"
        >
          <Skeleton className="h-9 w-32 rounded-lg sm:h-8" />
          <Skeleton className="h-9 w-30 rounded-lg sm:h-8" />
          <Skeleton className="size-9 rounded-lg sm:size-8" />
        </Stack>
      </Stack>
    </FrameHeader>

    {Array.from({ length: rows }).map((_, i) => (
      <FramePanel key={i} fit>
        <Stack
          direction="column"
          gap={2}
          align="stretch"
          justify="between"
          className="w-full sm:flex-row sm:items-start sm:gap-4"
        >
          <Stack align="start" gap={1} className="min-w-0 sm:flex-1">
            <Skeleton
              className={cn(
                "h-4 max-w-full",
                SKELETON_TITLE_WIDTHS[i % SKELETON_TITLE_WIDTHS.length],
              )}
            />
            <Skeleton className="h-3 w-32" />
          </Stack>
          <Stack direction="row" gap={2} align="center" className="flex-none">
            <Skeleton className="h-9 w-30 rounded-lg sm:h-8" />
            <Skeleton className="size-9 rounded-lg sm:size-8" />
          </Stack>
        </Stack>
      </FramePanel>
    ))}
  </Frame>
);
